module.exports = __webpack_public_path__ + "media/packs/images/flags/MV-d1acba1197ee9ce718bce98214753f5b.png";